import Box from '@mui/material/Box';
import { Outlet, useNavigate } from 'react-router-dom';
import { ActionBar, Header } from 'src/components/header';
import { AppTabs } from 'src/components/tab/AppTabs';
import { AppTab } from 'src/components/tab/AppTabs.interface';
import { PATHS } from 'src/constants/paths';
import { lang } from 'src/utils';

import { LocationListPageHeader } from './LocationListPage.styled';

export const LocationListPage = () => {
  const navigate = useNavigate();

  const locationListPageTabs: AppTab[] = [
    { label: lang.locationGroups, path: 'groups' },
    { label: lang.locations, path: 'locations' },
    { label: lang.unassignedLocations, path: 'unassigned' },
  ];

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <LocationListPageHeader>
        <AppTabs tabs={locationListPageTabs} useRouting basePath="/locations" />
        <Header
          actionBar={
            <ActionBar
              onHandleClick={() => {
                navigate(PATHS.LOCATION_ADD);
              }}
              type={lang.listLocationsPage}
            />
          }
        />
      </LocationListPageHeader>
      <Outlet /> {/* This renders the selected tab's route */}
    </Box>
  );
};
